"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "language-switcher" };
const _hoisted_2 = ["title", "onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.ALL_LANGUAGES, (lang) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: lang }, [
                (0, vue_1.createElementVNode)("div", {
                    class: (0, vue_1.normalizeClass)(`language-icon language-icon--${lang} language-icon-for-switcher`),
                    title: _ctx.title(lang),
                    onClick: ($event) => (_ctx.switchLanguageTo(lang))
                }, null, 10, _hoisted_2),
                _cache[0] || (_cache[0] = (0, vue_1.createTextVNode)("   ", -1))
            ], 64));
        }), 128))
    ]));
}
